<template>
  <div class="security-wrapper">
    <Title
      title="智慧安防"
      subTitle="Intelligent Security"
      width="450px"
    ></Title>
    <div class="content">
      <div class="left-con">
        <div class="num-item">
          <div class="item-icon"></div>
          <div class="num-con">
            <div class="title">安全巡防点</div>
            <div class="num">
              {{
                securityData && securityData.intelligentSecurity
                  ? securityData.intelligentSecurity.pointCount
                  : null
              }}<span class="unit">个</span>
            </div>
          </div>
        </div>
        <div class="num-item">
          <div class="item-icon"></div>
          <div class="num-con">
            <div class="title">巡防次数</div>
            <div class="num">
              {{
                securityData && securityData.intelligentSecurity
                  ? securityData.intelligentSecurity.guardCount
                  : null
              }}<span class="unit">次</span>
            </div>
          </div>
        </div>
        <div class="num-item">
          <div class="item-icon"></div>
          <div class="num-con">
            <div class="title">应急处置</div>
            <div class="num">
              {{
                securityData && securityData.intelligentSecurity
                  ? securityData.intelligentSecurity.callDealCount
                  : null
              }}<span class="unit">次</span>
            </div>
          </div>
        </div>
        <div class="num-item">
          <div class="item-icon"></div>
          <div class="num-con">
            <div class="title">消防报警</div>
            <div class="num">
              {{
                securityData && securityData.intelligentSecurity
                  ? securityData.intelligentSecurity.fireControlCount
                  : null
              }}<span class="unit">次</span>
            </div>
          </div>
          <div class="decoration"></div>
        </div>
        <div class="num-item">
          <div class="item-icon"></div>
          <div class="num-con">
            <div class="title">今日食品留样</div>
            <div class="num">
              {{
                securityData && securityData.intelligentSecurity
                  ? securityData.intelligentSecurity.foodCount
                  : null
              }}<span class="unit">件</span>
            </div>
          </div>
          <div class="decoration"></div>
        </div>
        <div class="num-item">
          <div class="item-icon"></div>
          <div class="num-con">
            <div class="title">实时样板间人数</div>
            <div class="num">
              {{
                securityData && securityData.intelligentSecurity
                  ? securityData.intelligentSecurity.nowHumanNumber
                  : null
              }}<span class="unit">人</span>
            </div>
          </div>
          <div class="decoration"></div>
        </div>
      </div>
      <div class="right-con">
        <div class="record-title">
          <div class="title-con">
            <div class="icon"></div>
            <div class="title">巡防记录</div>
          </div>
          <!-- <div class="more">更多</div> -->
        </div>
        <dv-scroll-board
          :config="recordConfig"
          style="width: 100%; height: 150px"
        />
        <div class="record-title">
          <div class="title-con">
            <div class="icon"></div>
            <div class="title">疫情防控分析</div>
          </div>
        </div>
        <div id="out-dia"></div>
      </div>
      <div class="right-bot">
        <div class="record-title">
          <div class="title-con">
            <div class="icon"></div>
            <div class="title">视频监控</div>
          </div>
          <div
            class="more"
            @click="
              openMonitorModal(monitorGroups[0].url, monitorGroups[0].url1, 0)
            "
          >
            更多
          </div>
        </div>
        <div class="block-content">
          <div
            class="radio-item"
            v-for="(item, index) in monitorGroups"
            :key="index"
            @click="openMonitorModal(item.url, item.url1, index)"
          >
            <div class="radio-location">{{ item.position }}</div>
            <!-- <video :id="`monitor-${index}`" muted></video> -->
            <img :src="item.url" alt="" />
          </div>
        </div>
      </div>
    </div>
    <m-dialog
      :show.sync="monitorShow"
      :no-head="true"
      @open="monitorOpen"
      @close="monitorClose"
      :append-to-body="true"
      width="85%"
      ref="mdialog"
    >
      <div class="preview-video-con">
        <iframe
          width="100%"
          :height="height"
          frameborder="0"
          scrolling="auto"
          :src="ysurl"
        ></iframe>
        <!-- <video 
        width="100%"
          :height="height"
          frameborder="0"
          scrolling="auto"
          :src="ysurl"></video> -->
      </div>
      <div class="preview-container vertical-scroll">
        <div class="vertical-item">
          <div
            class="preview-item videoitem"
            v-for="(item, index) in monitorList"
            :key="index"
            @click="changeVideoSrc(item.url, item.url1, index)"
          >
            <div class="video-name">{{ item.position }}</div>
            <!-- <video
              :class="previewIndex === index ? 'active-video' : ''"
              :id="`preview-${index}`"
              muted
            ></video> -->
            <img :src="item.url" alt="" />
          </div>
        </div>
      </div>
      <div class="leftimg" @click="prevItem"></div>
      <div class="rightimg" @click="nextItem"></div>
    </m-dialog>
  </div>
</template>

<script>
import Title from "@/components/Commen/CloseTitle";
const echarts = require("echarts");
import doubleChart from "./chart/out-in";
import Hls from "hls.js";
import { mapState, mapActions } from "vuex";

export default {
  components: {
    Title,
  },
  data() {
    return {
      branchId: 6627,
      securityData: null,
      recordConfig: {
        header: ["时间", "巡防点", "巡防人员", "情况说明"],
        rowNum: 4,
        // columnWidth: ['33%', '33%', '33%', '33%'],
        headerBGC: "rgba(0,0,0,0)",
        oddRowBGC: "rgba(103, 118, 137, 0.3)",
        evenRowBGC: "rgba(0,0,0,0)",
      },
      monitorList: [
        // {
        //   position: "南大门",
        //   url: "https://open.ys7.com/v3/openlive/J22989709_1_1.m3u8?expire=1679039743&id=426408646297223168&t=9527c7ed1304e0b25b96bdd465fe8f9f92bfeef351c3a49a292eb46871300bb3&ev=100",
        // },
        // {
        //   position: "康复医院",
        //   url: "https://open.ys7.com/v3/openlive/J22989709_2_1.m3u8?expire=1679039770&id=426408760196112384&t=ea822e1674c3be3a5f42f9d92f051922d15d83168d159f7fdd95036ed73da8cd&ev=100",
        // },
        // {
        //   position: "西大门",
        //   url: "https://open.ys7.com/v3/openlive/J22989709_3_1.m3u8?expire=1679039800&id=426408886876164096&t=e585a28c9c13de8a3fd5549be28326054edb7d26f57c02efdfe3fe7c18db12aa&ev=100",
        // },
        // {
        //   position: "星月广场",
        //   url: "https://open.ys7.com/v3/openlive/J22989709_4_1.m3u8?expire=1679039811&id=426408932337545216&t=9a66b207c19f283ebbfb8fda51761b51faab1e3435867e4697ebe328e5fb166e&ev=100",
        // },
        // {
        //   position: "棋盘广场",
        //   url: "https://open.ys7.com/v3/openlive/J22989709_5_1.m3u8?expire=1679039825&id=426408988982689792&t=2e88b1be2d422d8515c3e4009ea471ce40db65a4999735387c9176b7bbf21c6e&ev=100",
        // },
        // {
        //   position: "16号楼大厅",
        //   url: "https://open.ys7.com/v3/openlive/J22989709_6_1.m3u8?expire=1679039835&id=426409033480830976&t=92a14f7ebc2637bb4d0809288c21dd9c5c1a84a7e7c609451a29d7259ff25b01&ev=100",
        // },
        // {
        //   position: "亲水露台",
        //   url: "https://open.ys7.com/v3/openlive/J22989709_7_1.m3u8?expire=1679039849&id=426409090272866304&t=44cdabf23f7a0a10a0868530849ca288067746e33fd5b83ba2af77523fecc3e1&ev=100",
        // },
        // {
        //   position: "云湖跑道",
        //   url: "https://open.ys7.com/v3/openlive/J22989709_8_1.m3u8?expire=1679039860&id=426409136592146432&t=ec35a8c901f51a7807d8b6440a3c1a50e3c17d09a1ac68d2eacf9bf3c251e4cb&ev=100",
        // },
      ],
      monitorGroups: [],
      previewIndex: 0,
      $videoModal: null,
      monitorShow: false,
      player2: null,

      clickNum: 0,
      lastLeft: 0,
      maxClickNum: 0, // 最大点击次数
      ysurl: "", //萤石播放地址
      height: 800,
    };
  },
  computed: {
    ...mapState(["videodata"]),
  },
  async mounted() {
    this.securityData = this.$store.state.securityData;
    this.drawChart(this.securityData);

    let data = this.securityData.patrolRecord.map((el) => {
      return [
        this.formatterDate(el.executeDate),
        el.pointName,
        el.executeByName,
        el.resultStatusName,
      ];
    });
    this.recordConfig = {
      header: ["服务时间", "服务对象", "服务人员", "服务项目"],
      rowNum: 4,
      // columnWidth: [120, 80, 80],
      headerBGC: "rgba(0,0,0,0)",
      oddRowBGC: "rgba(103, 118, 137, 0.3)",
      evenRowBGC: "rgba(0,0,0,0)",
      data,
    };
    this.getData();
  },

  methods: {
    ...mapActions(["getVideoData"]),
    async getData() {
      let json = {
        branchId: this.branchId,
      };
      await this.getVideoData(json);
      // console.log(this.videodata.data.data)
      this.videodata.data.data.forEach((item, index) => {
        this.monitorList.push({
          position: item.name,
          url: item.iotUrl,
          url1: item.iotIp,
        });
      });
      this.monitorGroups = this.monitorList.slice(0, 4);
      this.$nextTick(() => {
        // console.log(this.monitorGroups)
        // this.playMonitorGroup();
      });
    },

    drawChart(data) {
      let arr = [
        data.epidemicPrevention.staff.staffIntoCount,
        data.epidemicPrevention.cultivatorMap.cultivatorIntoCount,
        data.epidemicPrevention.other.visitorIntoCount,
      ];
      let arr2 = [
        data.epidemicPrevention.staff.staffOutCount,
        data.epidemicPrevention.cultivatorMap.cultivatorOutCount,
        data.epidemicPrevention.other.visitorOutCount,
      ];
      this.doubleChart = echarts.init(document.getElementById("out-dia"));
      this.doubleChart.setOption(doubleChart(arr, arr2));
    },
    changeVideoSrc(hlsSrc, url1, index) {
      this.ysurl = url1;
      this.height = 800;
    },
    openMonitorModal(hlsSrc, url1, index) {
      this.ysurl = url1;
      // this.hlsModalSrc = hlsSrc;
      console.log(url1, index);
      this.previewIndex = index;
      this.monitorShow = true;
      this.height = 800;
    },
    // playMonitorGroup() {
    // console.log(`start load monitor group `);
    // this.monitorList.forEach((monitor, j) => {
    // if (monitor.player) {
    // this.$el.querySelector(`#monitor-${j}`).play();
    // } else {
    // const hlsSrc = monitor.url;
    // const $video = this.$el.querySelector(`#monitor-${j}`);
    // monitor.player = this.loadHls($video, hlsSrc);
    // monitor.player.on(Hls.Events.MANIFEST_PARSED, () => {
    // $video.pause();
    // });
    // }
    // });
    // },
    loadHls($video, hlsSrc) {
      // const hlsPlayer = new Hls({
      // maxBufferSize: 1000 * 1000,
      // });
      // hlsPlayer.loadSource(hlsSrc);
      // hlsPlayer.attachMedia($video);
      // hlsPlayer.on(Hls.Events.ERROR, (event, data) => {
      // console.error(data);
      // });
      // return hlsPlayer;
    },
    monitorOpen() {
      if (this.player2) {
        this.player2.destroy();
        this.player2 = null;
      }
      // this.$nextTick(() => {
      // this.$videoModal = document.querySelector("#monitor-modal");
      // this.player2 = this.loadHls(this.$videoModal, this.hlsModalSrc);
      // this.player2.on(Hls.Events.MANIFEST_PARSED, () => {
      // this.$videoModal.play();
      // });
      //预览
      // this.monitorList.forEach((monitor, j) => {
      // const hlsSrc = monitor.url;
      // const $video = document.querySelector(`#preview-${j}`);
      // monitor.player = this.loadHls($video, hlsSrc);
      // monitor.player.on(Hls.Events.MANIFEST_PARSED, () => {
      // $video.play();
      // });
      // });
      // });
    },
    monitorClose() {
      // this.$videoModal.pause();
    },
    timeConvert(timestamp) {
      //num:0 YYYY-MM-DD  num:1  YYYY-MM-DD hh:mm:ss // timestamp:时间戳
      //将时间戳转换成正常时间格式
      var date = new Date(timestamp); //时间戳为10位需*1000，时间戳为13位的话不需乘1000
      var Y = date.getFullYear() + "-";
      var M =
        (date.getMonth() + 1 < 10
          ? "0" + (date.getMonth() + 1)
          : date.getMonth() + 1) + "-";
      var D = date.getDate() + " ";
      var h = date.getHours() + ":";
      var m =
        (date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes()) +
        ":";
      var s = date.getSeconds();
      return Y + M + D + h + m + s;
    },
    formatterDate(item) {
      if (!item) return "";
      return this.timeConvert(item).substr(5).substr(0, 11);
    },
    nextItem() {
      // 如果点击次数小于数组长度-1时，执行左滑动效果。
      if (this.clickNum < this.monitorList.length - 1) {
        //获取当前元素宽度
        let width =
          document.querySelectorAll(".videoitem")[this.clickNum].offsetWidth;
        // 获取最后一个元素距离左侧距离
        let lastItemOffsetLeft =
          document.querySelectorAll(".videoitem")[this.monitorList.length - 1]
            .offsetLeft;
        // 获取可视区域宽度
        let lookWidth = document.querySelector(".vertical-scroll").clientWidth;
        console.log("移动前》》》", lastItemOffsetLeft, lookWidth);
        // 如果最后一个元素距离左侧的距离大于可视区域的宽度，表示最后一个元素没有出现，执行滚动效果
        if (lastItemOffsetLeft > lookWidth) {
          // 公示：滚动距离（元素的magin-left值） = 负的它自己的长度 + 上一次滑动的距离
          document.querySelector(".vertical-item").style.marginLeft = `${
            -width + this.lastLeft
          }px`;
          this.lastLeft = -width + this.lastLeft;
          this.clickNum += 1;
          // 记录到最后一个元素出现在可视区域时，点击次数的最大值。用于后面点击左侧箭头时判断右侧箭头的显示
          this.maxClickNum = this.clickNum;
        }

        /* 
         如果最后一个元素距离左侧的距离大于可视距离+自身的宽度，说明没有到最后一个, 显示右侧箭头，否则隐藏右侧箭头
         注意：这里要加上其自身的宽度，否则要多点击一下才会隐藏。因为点击的时候实际上最后一个元素还没有滚动，
         它距离左侧的距离是大于可视区域的（也就是说获取的是上一次点击之后，距离左侧的距离）
         所以这里要加上其自身的宽度
         看不懂的话不用管，反正加上就对了
       */
        this.showNextIcon = lastItemOffsetLeft > lookWidth + width;
      }
    },
    prevItem() {
      // 当点击次数大于0时才触发，这样当点击次数clickNum等于1的到时候，clickNum--等于0.根据计算属性的判断会隐藏掉左箭头
      if (this.clickNum > 0) {
        //获取当前元素宽度
        let width =
          document.querySelectorAll(".videoitem")[this.clickNum - 1]
            .offsetWidth;
        // 公示：滚动距离（元素的magin-left值） = 它自己的长度 + 上一次滑动的距离
        document.querySelector(".vertical-item").style.marginLeft = `${
          width + this.lastLeft
        }px`;
        this.lastLeft = width + this.lastLeft;
        //点击次数-1
        this.clickNum--;
        if (this.clickNum < this.maxClickNum) {
          this.showNextIcon = true;
        }
      }
    },
  },
  beforeDestroy() {
    // this.player1.destroy()
    this.monitorList.forEach((monitor) => {
      if (monitor.player) {
        monitor.player.destroy();
      }
    });
    if (this.player2) {
      this.player2.destroy();
    }
  },
};
</script>

<style lang="scss" scoped>
.content {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  flex-direction: column;
  width: 466px;
  // width: 100%;
  height: auto;
}
.record-title {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  line-height: 30px;
  color: #fff;
  .title-con {
    display: flex;
    align-items: center;
    justify-content: flex-start;
  }
  .icon {
    width: 24px;
    height: 24px;
    background: url("../../assets/index/title-icon.png") no-repeat center;
    background-size: contain;
    vertical-align: middle;
  }
  .title {
  }
  .more {
    color: rgb(81, 218, 239);
    font-size: 14px;
    cursor: pointer;
  }
}
.left-con {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  width: 100%;
  flex-wrap: wrap;
  .num-item {
    display: flex;
    width: 155px;
    height: auto;
    align-items: center;
    flex-wrap: wrap;
    .item-icon {
      width: 40px;
      height: 45px;
      background: url("../../assets/index/security-item.png") no-repeat center
        top;
      background-size: cover;
    }
    .num-con {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      .title {
        color: rgb(121, 218, 255);
        font-size: 16px;
        font-weight: normal;
        font-family: "Microsoft Yahei", Arial, "sans-serif";
      }
      .num {
        font-size: 30px;
        color: #fff;
        font-weight: bolder;
        letter-spacing: 0.02em;
        .unit {
          font-size: 15px;
          color: #fff;
          vertical-align: baseline;
        }
      }
    }
    .decoration {
      width: 131px;
      height: 18px;
      background: url("../../assets/index/decoration.png") no-repeat center;
      background-size: contain;
    }
  }
}
.right-con {
  width: 100%;
  #out-dia {
    width: 100%;
    height: 170px;
  }
}
.right-bot {
  width: 100%;
  height: 300px;
  .block-content {
    padding: 0px 5px;
    box-sizing: border-box;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-wrap: wrap;
    .radio-item {
      position: relative;
      width: 200px;
      height: 120px;
      background: #346da4;
      margin: 5px 5px;
      .radio-location {
        position: absolute;
        left: 6px;
        bottom: 7px;
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #ffffff;
      }
      video {
        width: 100%;
        // height: 100%;
        height: auto;
      }
      img {
        width: 100%;
        height: 100%;
      }
    }
  }
}

.preview-video-con {
  width: 100%;
  margin: 0 auto;
}
#monitor-modal {
  width: 100%;
  height: auto;
}
#myPlayer {
  width: 100%;
  height: auto;
}

.preview-container {
  width: 100%;
  height: 120px;
  overflow: hidden;
  .vertical-item {
    transition: all 0.3s ease;
    display: -webkit-box;
    overflow: hidden;
  }
}
.preview-item {
  width: 200px;
  height: 120px;
  margin: 10px 5px;
  position: relative;
  img {
    width: 200px;
    height: 120px;
  }
}
.preview-container video {
  position: relative;
  z-index: 2;
  width: 100%;
  height: auto;
}
.active-video {
  border: 3px solid #2b79bb;
}
.video-name {
  position: absolute;
  bottom: 10px;
  left: 50%;
  transform: translateX(-50%);
  color: #fff;
  font-size: 10px;
  z-index: 3;
}
.leftimg {
  width: 20px;
  height: 20px;
  background: url("../../assets/security/left.png") no-repeat;
  background-size: 20px;
  position: absolute;
  bottom: 50px;
  left: 0px;
  z-index: 99;
}
.rightimg {
  width: 20px;
  height: 20px;
  background: url("../../assets/security/right.png") no-repeat;
  background-size: 20px;
  position: absolute;
  bottom: 50px;
  right: 0px;
  z-index: 99;
}
</style>
<style>
.m-dialog {
  background: #ffffff !important;
  position: relative;
  margin-top: 0vh !important;
  top: 50%;
  transform: translateY(-50%);
}
</style>
